// Fashion till features that a store can switch off in its POS config
// (cwr_pos_config.config_json): "fashionHolds": "N" hides size holds and
// "fashionMarkdowns": "N" hides markdowns / final sale. Both are on otherwise.
// Holds need cwr_fsh_hold and markdowns cwr_fsh_markdown; where a table isn't
// there yet the server answers reads with an empty list and refuses writes with
// "… aren't set up on this server yet", which the till shows as it is.
import usePOSConfigStore from "../../stores/usePOSConfigStore";

export const FEATURE_FLAGS = Object.freeze({ holds: "fashionHolds", markdowns: "fashionMarkdowns" });

const isOff = (value) => value === false || String(value ?? "").trim().toUpperCase() === "N";

// { holds, markdowns } for this POS config.
export function fashionFeatures(posConfig) {
  return { holds: !isOff(posConfig?.[FEATURE_FLAGS.holds]), markdowns: !isOff(posConfig?.[FEATURE_FLAGS.markdowns]) };
}

const current = () => fashionFeatures(usePOSConfigStore.getState()?.posConfig);

// Read when each screen renders, so a config sync switches them without a reload.
export const FASHION_FEATURES = Object.freeze({
  get holds() {
    return current().holds;
  },
  get markdowns() {
    return current().markdowns;
  },
});
